module.exports = "/static/js/d755df03f07e8c40d8b970c8b1e8f734.png";